// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .property-form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    mat-form-field {
      width: 100%;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/components/app-wizard/property-dialog.component.ts"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;IACA;MACE,WAAW;IACb","sourcesContent":["\n    .property-form {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n    mat-form-field {\n      width: 100%;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
